import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useState } from 'react'

import classes from './JumpPill.module.scss'
import { ReactComponent as ArrowUpIcon } from '../../../../assets/images/common/icons/arrow-up.svg'

const JumpPill = ({ sections, activeIndex, onSelect }) => {
  const [open, setOpen] = useState(false)

  const current = sections[activeIndex] ?? sections[0]

  const handleSelect = (index) => {
    onSelect(index)
    setOpen(false)
  }

  return (
    <div className={classes.wrapper}>
      {open && (
        <div className={classes.menu}>
          {sections.map((s, i) => (
            <button
              key={s.id}
              type='button'
              className={classes.option}
              onClick={() => handleSelect(i)}
            >
              <span className={classes.index}>{`#${i + 1}`}</span>
              <span className={classes.label}>{s.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        type='button'
        className={classes.pill}
        onClick={() => setOpen(o => !o)}
      >
        <span className={classes.prefix}>Jump to</span>
        <span>{current?.label}</span>
        <ArrowUpIcon className={classnames(classes.chevron, { [classes.open]: open })} />
      </button>
    </div>
  )
}

JumpPill.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
}

export default JumpPill
